module.exports = __webpack_public_path__ + "img/bc2_home.d0c904cd.png";